<template>
    <v-stepper ref="stepper"  :items="['Datos Personales', 'Datos Adicionales', 'Arma']">
        <template v-slot:item.1>
            <v-card title="Datos Personales" flat class="mb-3">
                <v-card-text>
                    <v-row>
                        <v-col cols="12" sm="4">
                            <v-text-field color="cyan-darken-1" label="Carnet" v-model="item_personal_civil.carnet"
                                :error-messages="showFieldsErrors('carnet')" 
                                @input="limitarLongitudCarnet"
                                variant="outlined" type="number" />
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-text-field color="cyan-darken-1" label="Complemento" v-model="item_personal_civil.complemento"
                                :error-messages="showFieldsErrors('carnet')" 
                                @input="limitarLongitudCarnet"
                                variant="outlined" type="text" />
                        </v-col>

                        <v-col cols="12" sm="2">
                            <!-- <v-text-field color="cyan-darken-1" label="Expedido" v-model="item_personal_civil.expedido"
                                :error-messages="showFieldsErrors('expedido')" variant="underlined" /> -->
                                <v-select color="cyan-darken-1" v-model="item_personal_civil.expedido"  
                            :items="['LP','CB','SC','OR','PT','PA','BN','TJ','CH','QR']"  label="Expedido" 
                            :error-messages="showFieldsErrors('expedido')" 
                            variant="outlined"></v-select>
                        </v-col>
                        <v-divider></v-divider>
                        <v-col cols="12" sm="4">
                            <v-text-field color="cyan-darken-1" label="Primer Apellido"
                                v-model="item_personal_civil.primer_apellido"
                                :error-messages="showFieldsErrors('primer_apellido')" 
                                @input="validarTexto('primer_apellido')" variant="outlined" />
                        </v-col>

                        <v-col cols="12" sm="4">
                            <v-text-field color="cyan-darken-1" label="Segundo Apellido"
                                v-model="item_personal_civil.segundo_apellido"
                                :error-messages="showFieldsErrors('segundo_apellido')"
                                @input="validarTexto('segundo_apellido')"
                                variant="outlined" />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <!-- <v-text-field color="cyan-darken-1" label="Primer Nombre"
                                v-model="item_personal_civil.primer_nombre"
                                :error-messages="showFieldsErrors('primer_nombre')" 
                                @input="convertirAMayusculas('primer_nombre')"
                                variant="outlined"/> -->
                                <v-text-field color="cyan-darken-1" label="Primer Nombre"
                                v-model="item_personal_civil.primer_nombre"
                                :error-messages="showFieldsErrors('primer_nombre')" 
                                @input="validarTexto('primer_nombre')"
                                variant="outlined"/>
                        </v-col>

                        <v-col cols="12" sm="4">
                            <v-text-field color="cyan-darken-1" label="Segundo Nombre"
                                v-model="item_personal_civil.segundo_nombre"
                                :error-messages="showFieldsErrors('segundo_nombre')" 
                                @input="validarTexto('segundo_nombre')"
                                variant="outlined" />
                        </v-col>
                        <v-col cols="12" sm="2">
<!--                             <v-text-field color="cyan-darken-1" label="Genero" v-model="item_personal_civil.genero"
                                :error-messages="showFieldsErrors('genero')" variant="outlined" density="comfortable" /> -->
                                <v-select color="cyan-darken-1" v-model="item_personal_civil.genero"  
                            :items="['M','F']"  label="Género" 
                            :error-messages="showFieldsErrors('genero')" 
                            variant="outlined"></v-select>
                        </v-col>    
                        <v-col cols="12" sm="2">
                                <v-text-field color="cyan-darken-1" label="Fecha de Nacimiento" type="date"
                                v-model="item_personal_civil.fecha_nacimiento"
                                variant="outlined" />
                        </v-col>                      
<v-divider></v-divider>
                        
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="warning" variant="outlined" @click="toClear">
                        <v-icon icon="mdi-delete" />
                    </v-btn>

                    <v-btn color="green-darken-1" variant="outlined" @click="saveChild">
                        <v-icon icon="mdi-content-save-outline"></v-icon>&nbsp;Guardar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </template>

        <template v-slot:item.2>
            <!-- Step 2: Datos Adicionales -->
            <v-card title="Datos Adicionales" flat class="mb-3">
                <v-card-text>
                    <v-row>
                        <!--OPCIONALMENTE APAGADO EL ID-->
                        <v-col cols="12" sm="2">
                            <v-text-field color="cyan-darken-1" label="carnet" v-model="complementarios.carnet"
                                :value="this.complementarios.carnet" variant="outlined" readonly/>
                        </v-col>
                        <!-- Add form fields for Datos Adicionales here -->
                        <v-col cols="12" sm="4">
                            <v-text-field color="cyan-darken-1" label="Numero Licencia"
                                v-model="complementarios.numero_licencia" variant="outlined"/>
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field color="cyan-darken-1" label="Categoria Licencia"
                                v-model="complementarios.categoria_licencia" variant="outlined"/>
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field color="cyan-darken-1" label="Departamento Registro"
                                v-model="complementarios.departamento_registro" variant="outlined"/>
                        </v-col>
                        <v-col cols="12" sm="2">
                                 <v-text-field color="cyan-darken-1" label="Fecha de Nacimiento" type="date"
                                v-model="complementarios.fecha_vencimiento"
                                variant="outlined" />
                        </v-col>  
                        <v-col cols="12" sm="4">
                            <v-text-field color="cyan-darken-1" label="Telefono"
                                v-model="complementarios.telefono" variant="outlined"/>
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field color="cyan-darken-1" label="Celular"
                                v-model="complementarios.celular" variant="outlined"/>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="warning" variant="outlined" @click="toClearComplementarios">
                        <v-icon icon="mdi-delete" />
                    </v-btn>

                    <v-btn color="cyan-darken-1" variant="outlined" @click="saveComplementarios">
                        <v-icon icon="mdi-content-save-outline"></v-icon>&nbsp;Guardar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </template>

        <template v-slot:item.3>
            <div>
                <v-card title="Datos de Arma" flat class="mb-3">
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" sm="2">
                            <v-text-field color="cyan-darken-1" label="carnet" v-model="armas.carnet"
                                :value="this.armas.carnet" variant="outlined" readonly/>
                        </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field color="cyan-darken-1" label="Serie de Arma" v-model="armas.serie_arma"
                                @input="convertirAMayusculas('serie_arma')" variant="outlined" />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-select color="cyan-darken-1" v-model="armas.calibre"  
                            :items="['7,62 x 51 mm.','7,62 x 39 mm.','5,56 x 45 mm.','7,65 x 54 mm.','9 x 19 mm.','0,30``','12','0,44``','0,45``','1,5``','12 my.',
                        '16 mm.','20 mm.','22 mm.','26,65 mm.','3,5``','30``','37-38','37 mm.','38 mm.','4,2``','40 mm.',
                        '44``','45``','7,00 mm.','7,65 mm.','9 mm.']" density="comfortable" label="Calibre" variant="outlined"
                            ></v-select>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field color="cyan-darken-1" label="Marca" v-model="armas.marca" 
                                @input="convertirAMayusculas('marca')" variant="outlined"/>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field color="cyan-darken-1" label="Tipo" v-model="armas.tipo"
                                @input="convertirAMayusculas('tipo')" variant="outlined"/>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field color="cyan-darken-1" label="Nùmero de Matricula" v-model="armas.numero_matricula" 
                                @input="convertirAMayusculas('numero_matricula')" variant="outlined"/>
                            </v-col>
                            <v-col cols="12" sm="2">
                                <v-text-field color="cyan-darken-1" label="Fecha de Registro" type="date"
                                v-model="armas.fecha_registro" variant="outlined"
                                 />
                        </v-col> 
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="warning" variant="outlined" @click="toCleararmas">
                            <v-icon icon="mdi-delete" />
                        </v-btn>

                        <v-btn color="cyan-darken-1" variant="outlined" @click="saveArma">
                            <v-icon icon="mdi-content-save-outline"></v-icon>&nbsp;Guardar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </div>
        </template>
    </v-stepper>
</template>

<script>
import ArmasService from "@/http/services/ArmasService";
import PersonalCivilService from "@/http/services/PersonalCivilService";
import ComplementariosService from "@/http/services/ComplementariosService";
import {
    defineComponent
} from 'vue';

export default defineComponent({
    props: ['p_item_personal_civil', 'p_fields_errors'],
    emits: ['saveParent', 'isClear'],
    data() {
        
        return {
            item_personal_civil: this.p_item_personal_civil || {
                //grados: '',
                genero: '',
                primer_nombre: '',
                segundo_nombre: '',
                primer_apellido: '',
                segundo_apellido: '',
                carnet: null,
                expedido: '',
                complemento:'',
                fecha_nacimiento:'',
            },
            obj_Personal: new PersonalCivilService(),

            complementarios: { // Inicializa complementarios aquí
                carnet: '',
                numero_licencia:'',
                categoria_licencia:'',
                departamento_registro:'',
                telefono:'',
                celular:'',
                fecha_vencimiento:'',
            },
            obj_Complementarios: new ComplementariosService(),

            armas: this.p_armas || {
                carnet: '',
                serie_arma: '',
                calibre: '',
                marca: '',
                tipo: '',
                numero_matricula: '',
                fecha_registro: '',
            },
            obj_Armas: new ArmasService(),
        };
    },

    watch: {
        p_item_personal_civil() {
            this.item_personal_civil = this.p_item_personal_civil || {
                genero: '',
                primer_nombre: '',
                segundo_nombre: '',
                primer_apellido: '',
                segundo_apellido: '',
                carnet: null,
                expedido: '',
                complemento:'',
                fecha_nacimiento:'',
            };
        },

        p_armas() {
            this.armas = this.p_armas || {
                carnet: '',
                serie_arma: '',
                calibre: '',
                marca: '',
                tipo: '',
                numero_matricula: '',
                fecha_registro: '',
            };
        },
    },

    computed: {
        showFieldsErrors() {
            return function (property) {
                if (this.p_fields_errors && this.p_fields_errors[property]) {
                    return this.p_fields_errors[property][0];
                }
                return '';
            };
        },
    },

    methods: {
       
        limitarLongitudCarnet() {
      if (this.item_personal_civil.carnet.length > 8) {
        this.item_personal_civil.carnet = this.item_personal_civil.carnet.substring(0, 8);
      }
    },
    convertirAMayusculas(propiedad) {
      this.armas[propiedad] = this.armas[propiedad].toUpperCase();
    },
        validarTexto(propiedad) {
            this.item_personal_civil[propiedad] = this.item_personal_civil[propiedad]
                .replace(/\d/g, '').toUpperCase();
        },
        // Método para recibir el ID en el evento saveParent
        onParentSave(item_personal_civil, nuevoId) {
            // Hacer algo con el nuevoId, si es necesario
            console.log('ID recibido:', nuevoId);
            // Continuar con el manejo de datos si es necesario
        },
        async saveChild() {
            console.log('Guardando datos:', this.item_personal_civil);
            const response = await this.obj_Personal.store(this.item_personal_civil);
            console.log('Respuesta del servidor:', response);

            // Verificar si 'id' está presente en la respuesta del servidor
            const nuevoId = response.post && response.post.carnet;

            console.log("Este es el  Carnet del Civil ", nuevoId);
            // Actualizar el valor de carnet en complementarios
            this.complementarios.carnet = nuevoId;
            console.log("Este es el Carnet del Civil ", this.complementarios.carnet);
            // Emitir el evento con el ID
            this.$emit('saveParent', this.item_personal_civil, nuevoId);

            // Verificar si 'stepper' está presente antes de intentar acceder a 'next'
            if (this.$refs.stepper) {
                this.$refs.stepper.next();
            }
            //this.$refs.stepper.next();
        },
        toClear() {
            this.item_personal_civil = {
                genero: '',
                primer_nombre: '',
                segundo_nombre: '',
                primer_apellido: '',
                segundo_apellido: '',
                carnet: null,
                complemento: '',
                expedido: '',
                fecha_nacimiento:'',
            };
        },
        async saveComplementarios() {
            console.log('Guardando datos:', this.complementarios);
            const response = await this.obj_Complementarios.store(this.complementarios);
            console.log('Respuesta del servidor:', response);
            this.$emit('saveParent', this.complementarios);
            if (this.$refs.stepper) {
                this.$refs.stepper.next();
            }

        },

        toClearComplementarios() {
            this.complementarios = {
                carnet: '',
                numero_licencia:'',
                categoria_licencia:'',
                departamento_registro:'',
                telefono:'',
                celular:'',
                fecha_vencimiento:'',
            };
        },

        async saveArma() {
            try {
                this.armas.carnet = this.complementarios.carnet;
                console.log('Guardando datos:', this.armas);
                const response = await this.obj_Armas.store(this.armas);
                console.log('Respuesta del servidor:', response);
                this.$emit('saveParent', this.armas);
                this.$router.push('/home');
            } catch (error) {
                console.error('Error al guardar datos:', error);
            }
        },
        toCleararmas() {
            this.armas = {
                carnet: '',
                serie_arma: '',
                calibre: '',
                marca: '',
                tipo: '',
                numero_matricula: '',
                fecha_registro: '',
            };
        },

    },
});
</script>
